import type { OnboardingStatus } from "./schemas/onboarding-status.schema";

export interface QuestLevel {
  id: keyof OnboardingStatus["steps"];
  label: string;
  description: string;
  done: boolean;
  locked: boolean;
  current: boolean;
}

const QUEST_LEVEL_META: Record<
  keyof OnboardingStatus["steps"],
  Pick<QuestLevel, "label" | "description">
> = {
  importTeam: {
    label: "Assemble your team",
    description: "Import teammates to fill your pulse data.",
  },
  giveKudos: {
    label: "Send your first kudos",
    description: "Locked until your team is in Pulsewise.",
  },
  dailyCheckIn: {
    label: "Launch a daily check-in",
    description: "Locked until you send your first kudos.",
  },
};

function getQuestSteps(status?: OnboardingStatus): OnboardingStatus["steps"] {
  return (
    status?.steps ?? {
      importTeam: false,
      giveKudos: false,
      dailyCheckIn: false,
    }
  );
}

export function questXp(status?: OnboardingStatus): number {
  const steps = getQuestSteps(status);
  return Number(steps.importTeam) + Number(steps.giveKudos) + Number(steps.dailyCheckIn);
}

export function buildQuestLevels(status?: OnboardingStatus): QuestLevel[] {
  const steps = getQuestSteps(status);

  return [
    {
      id: "importTeam",
      ...QUEST_LEVEL_META.importTeam,
      done: steps.importTeam,
      locked: false,
      current: !steps.importTeam,
    },
    {
      id: "giveKudos",
      ...QUEST_LEVEL_META.giveKudos,
      done: steps.giveKudos,
      locked: !steps.importTeam,
      current: steps.importTeam && !steps.giveKudos,
    },
    {
      id: "dailyCheckIn",
      ...QUEST_LEVEL_META.dailyCheckIn,
      done: steps.dailyCheckIn,
      locked: !steps.importTeam || !steps.giveKudos,
      current: steps.importTeam && steps.giveKudos && !steps.dailyCheckIn,
    },
  ];
}
